export const GlobalEventEmitter = new EventTarget()
